import styles from './style.module.css'
import api from "../../../api";
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/ru';
import { HiOutlinePlusCircle } from 'react-icons/hi'

const SchoolsSection = () => {
    const [schools, setSchools] = useState([])
    const activeSchools = schools.results?.filter(school => school.is_active);

    useEffect(() => {
        api.getSchools()
            .then((data) => {
                setSchools(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        <div className={styles.schools_area}>
            <div className={styles.schools_area__title}>
                <h1>Школа московского фтизиатр<span className={styles.last_button}>а</span></h1>
                <div className={styles.schools_area__title__season}>8 сезон</div>
            </div>
            <div className={styles.schools_area__announ}>
                <h3>Ближайшее занятие</h3>
                {activeSchools && activeSchools.length > 0 ? (
                    schools.results?.map((school) => {
                        return school.is_active ? (
                            <div className={styles.card}>
                                <div className={styles.col}>
                                    <div className={styles.name}>Дата: </div>
                                    <div className={styles.content}>
                                        <Moment locale='ru' format='LL'>
                                            {school.date}
                                        </Moment>
                                    </div>
                                </div>
                                <div className={styles.col}>
                                    <div className={styles.name}>Наименование: </div>
                                    <div className={styles.content}>{school.title}</div>
                                </div>
                                <div className={styles.col}>
                                    <div className={styles.name}>Руководители: </div>
                                    <div className={styles.content}>{school.managements}</div>
                                </div>
                                <div className={styles.col}>
                                    <div className={styles.name}>Сезон: </div>
                                    <div className={styles.content}>№{school.season.season_number}</div>
                                </div>
                                <div className={styles.col}>
                                    <div className={styles.name}>Номер: </div>
                                    <div className={styles.content}>№{school.number}</div>
                                </div>
                                {school.program &&
                                    <div className={styles.col}>
                                        <div className={styles.name}>Программа: </div>
                                        <div className={styles.content}><Link to={school.program}>Скачать</Link></div>
                                    </div>
                                }
                            </div>
                        ) : null;
                    })
                ) : (
                    <div className={styles.card}>
                        <div className={styles.col}>
                            <div className={styles.name}>Наименование: </div>
                            <div className={styles.content}>Организационно-методическая и консультативная помощь по фтизиатрии медицинским организациям нетуберкулезного профиля</div>
                        </div>
                        <div className={styles.col}>
                            <div className={styles.name}>Руководители: </div>
                            <div className={styles.content}>Котова Е.А., к.м.н., зам. директора по научной и организационно-методической работе ГБУЗ «МНПЦ борьбы с туберкулезом ДЗМ», доцент кафедры фтизиатрии ФГБОУ ДПО «РМАНПО» Минздрава России;
                                Оганезова Г.С., к.м.н., заведующая филиалом по ЮАО ГБУЗ «МНПЦ борьбы с туберкулезом ДЗМ», доцент кафедры фтизиатрии ФГБОУ ДПО «РМАНПО» Минздрава России</div>
                        </div>
                        <div className={styles.col}>
                            <div className={styles.name}>Сезон: </div>
                            <div className={styles.content}>№ 8</div>
                        </div>
                        <div className={styles.col}>
                            <div className={styles.name}>Номер: </div>
                            <div className={styles.content}>№ 1</div>
                        </div>
                    </div>
                )}

            </div>
            <div className={styles.schools_area__info_1}>Все тематические занятия Школы московского фтизиатра подаются на аккредитацию в Координационном Совете по развитию непрерывного медицинского и фармацевтического образования Минздрава России для начисления слушателям 6 баллов (кредитов)</div>
            <div className={styles.schools_area__info_2}>
                <div className={styles.schools_area__info_2__text}>
                    Занятия Школы московского фтизиатра пройдут в дистанционном формате на Российском медицинском портале Румедо, http://rumedo.ru/.
                </div>
                <button className={styles.schools_area__more}>
                    <Link to="/schools/">
                        <div className={styles.content}>
                            <span className={styles.text}>Расписание</span> <span className={styles.icon}><HiOutlinePlusCircle /></span>
                        </div>
                    </Link>
                </button>
            </div>
        </div>
    );
}

export default SchoolsSection;